import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import aboutImage from '@/assets/about-image.png';

export const About = () => {
  const { t } = useTranslation();
  const paragraphs = t('about.paragraphs', { returnObjects: true }) as string[];

  return (
    <section id="about" className="py-24 lg:py-32 bg-background relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start relative pt-4 pr-4">
          <div
            className="absolute top-0 left-0 h-px pointer-events-none"
            style={{
              right: '14px',
              background: 'linear-gradient(to right, transparent 0%, hsl(290 46% 49%) 40%, hsl(290 46% 49%) 100%)',
            }}
          />
          <svg
            className="absolute pointer-events-none"
            style={{ top: '-0.5px', right: '-0.5px', width: '16px', height: '16px' }}
            viewBox="0 0 16 16"
            fill="none"
          >
            <line x1="0" y1="0.5" x2="15.5" y2="16" stroke="hsl(290 46% 49%)" strokeWidth="1" />
          </svg>
          <div
            className="absolute bottom-0 w-px pointer-events-none"
            style={{
              top: '15px',
              right: '0px',
              background: 'linear-gradient(to bottom, hsl(290 46% 49%) 0%, hsl(290 46% 49%) 60%, transparent 100%)',
            }}
          />

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1 }}
          >
            <div className="flex items-center gap-4 text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-tight mb-10 text-foreground">
              <img src="/title-icon.png" alt="" className="w-8 h-8 md:w-10 md:h-10" />
              {t('about.label')}
            </div>

            <div className="space-y-5">
              {paragraphs.map((text, i) => (
                <motion.p
                  key={i}
                  className={i === 0 ? "text-primary text-lg md:text-xl font-semibold leading-relaxed" : "text-foreground/70 leading-relaxed"}
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.2 + i * 0.1 }}
                >
                  {text}
                </motion.p>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative"
          >
            <div className="flex items-center justify-center h-[500px] lg:h-[600px]">
              <motion.img
                src={aboutImage}
                alt="Rocket"
                className="w-48 md:w-56 lg:w-64 object-contain"
                animate={{ y: [0, -20, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
